import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-warning',
  templateUrl: './modal-warning.component.html',
  styleUrls: ['./modal-warning.component.css']
})
export class ModalWarningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-warning/modal-warning.component.ts